import { render, staticRenderFns } from "./UtilityEmptyLink.vue?vue&type=template&id=5d5995c9&scoped=true"
import script from "./UtilityEmptyLink.vue?vue&type=script&lang=js"
export * from "./UtilityEmptyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5995c9",
  null
  
)

export default component.exports